/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpReviewPAC from './pre-op-review-pac';
import PreOpReviewPACDetail from './pre-op-review-pac-detail';
import PreOpReviewPACUpdate from './pre-op-review-pac-update';
import PreOpReviewPACDeleteDialog from './pre-op-review-pac-delete-dialog';

const PreOpReviewPACRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpReviewPAC />} />
    <Route path="new" element={<PreOpReviewPACUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpReviewPACDetail />} />
      <Route path="edit" element={<PreOpReviewPACUpdate />} />
      <Route path="delete" element={<PreOpReviewPACDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpReviewPACRoutes;
